webpackJsonp([7],{

/***/ 700:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NotFound_css__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NotFound_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__NotFound_css__);
/* harmony default export */ __webpack_exports__["default"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"NotFound"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Sorry, page not found!"));});

/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(853);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":false}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(692)(content, options);
if(content.locals) module.exports = content.locals;


/***/ }),

/***/ 853:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(691)(true);
// imports


// module
exports.push([module.i, ".NotFound{padding-top:100px;text-align:center}", "", {"version":3,"sources":["C:/Users/James/Documents/InteractiveStories/interactive-stories-website/src/containers/NotFound.css"],"names":[],"mappings":"AAAA,UACE,kBAAmB,AACnB,iBAAmB,CACpB","file":"NotFound.css","sourcesContent":[".NotFound {\r\n  padding-top: 100px;\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/7.66aa75f2.chunk.js